import React from 'react';
import styled from 'styled-components';
import { string } from 'prop-types';
import {
	AccentColor, DarkAccentColor, Secondary50,
	Secondary100, DisableColor, ColorDefs,
	Grey50,Grey500,Grey700,Grey100
} from '../../Colors';

const TextButtonBase = styled.button`
    text-decoration: none;
    text-transform: none;
    background-color : transparent;
    border : none;
    &:focus{
        outline : 0;
    }
`;

const PrimaryTextButton = styled(TextButtonBase)`
	color : ${AccentColor};
	&:focus{
			background-color: ${Secondary100};
			color: ${DarkAccentColor};
	}
	&:hover{
		background-color: ${Secondary50};
		color: ${DarkAccentColor};
	}
	&:disabled {
		background-color: transparent;
		color: ${DisableColor};
	}
`;

const DefaultTextButton = styled(TextButtonBase)`
	color : ${Grey500};
	&:focus{
			background-color: ${Grey100};
			color: ${Grey700};
	}
	&:hover{
		background-color: ${Grey50};
		color: ${Grey700};
	}
	&:disabled {
		background-color: transparent;
		color: ${DisableColor};
	}
`;

const TextButton = ({ color = ColorDefs.primary, ...props }) => {
	if(color === ColorDefs.primary){
		return <PrimaryTextButton {...props}/>;
	}
	else if(color === ColorDefs.default){
		return <DefaultTextButton {...props}/>;
	}
	return null;
};

TextButton.propTypes = {
	color: string,
};

export { TextButtonBase };

export default TextButton;